import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = ({ company }) => {
  const {
    name = 'Company Name',
    logo = null,
    primaryColor = '#2563EB',
    totalProjects = 0,
    activeConfigurations = 0
  } = company;

  const stats = [
    {
      label: 'Total Projects',
      value: totalProjects,
      icon: 'FolderOpen',
      color: 'text-primary'
    },
    {
      label: 'Active Configurations',
      value: activeConfigurations,
      icon: 'Settings',
      color: 'text-accent'
    },
    {
      label: 'Last Updated',
      value: new Date()?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      icon: 'Calendar',
      color: 'text-secondary'
    }
  ];

  return (
    <div className="bg-surface border-b border-border px-6 py-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="flex items-center gap-4">
            {logo ? (
              <Image
                src={logo}
                alt={`${name} company logo showing brand identity`}
                className="h-16 w-16 rounded-lg object-cover border-2 border-border"
              />
            ) : (
              <div
                className="h-16 w-16 rounded-lg flex items-center justify-center text-white font-bold text-2xl"
                style={{ backgroundColor: primaryColor }}
              >
                {name?.charAt(0)?.toUpperCase()}
              </div>
            )}
            <div>
              <h1 className="text-2xl font-bold text-text-primary">Welcome back!</h1>
              <p className="text-text-secondary mt-1">
                Manage your {name} visualizer configuration
              </p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            {stats?.map((stat, index) => (
              <div
                key={index}
                className="bg-card border border-border rounded-lg p-4 text-center"
              >
                <Icon
                  name={stat?.icon}
                  size={20}
                  className={`${stat?.color} mx-auto mb-2`}
                />
                <div className="text-2xl font-bold text-text-primary">{stat?.value}</div>
                <div className="text-xs text-text-secondary mt-1">{stat?.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;